export const GetIndividualJustification = (scorecardId: string, id: number) =>
    `EmploymentEquity/IndividualJustifications/${scorecardId}/${id}`;

export const CreateIndividualJustification = 'EmploymentEquity/IndividualJustifications';

export const UpdateIndividualJustification = 'EmploymentEquity/IndividualJustifications';

export const DeleteIndividualJustification = (scorecardId: string, id: number) =>
    `EmploymentEquity/IndividualJustifications/${scorecardId}/${id}`;
